import React, { useState } from "react";
import { FaArrowLeftLong, FaArrowRightLong } from "react-icons/fa6";
import { MdOutlineRateReview } from "react-icons/md";
import ResultFeedbackModal from "./ResultFeedbackModal";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import {
  feedbackStatusLoadedState,
  feedbackSubmittedState,
} from "../../../utils/recoil";

const NavigationButtons = ({ setSelectedIndex }) => {
  const [feedbackVisible, setFeedbackVisible] = useState(false);
  const feedbackSubmitted = useRecoilValue(feedbackSubmittedState);
  const feedbackStatusLoaded = useRecoilValue(feedbackStatusLoadedState);
  const { t } = useTranslation("result");
  const showFeedbackButton = feedbackStatusLoaded && !feedbackSubmitted;

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <div
        className={`flex w-full items-center gap-4 mt-5 md-max:flex-col md-max:items-stretch md-max:mb-[8rem] ${
          showFeedbackButton ? "justify-between" : "justify-end"
        }`}
      >
        {showFeedbackButton && (
          <button
            type="button"
            onClick={() => setFeedbackVisible(true)}
            className="py-5 px-8 md-max:py-3 border border-[#3D74C0] text-[#3D74C0] rounded-[10px] flex gap-3 text-lg md-max:text-base font-medium items-center justify-center bg-white"
          >
            <MdOutlineRateReview className="text-2xl md-max:text-xl" />
            {t("feedbackModal.openButton")}
          </button>
        )}

        <div className="flex justify-end gap-4 md-max:grid md-max:grid-cols-2 md-max:w-full">
          <button
            onClick={() => {
              scrollToTop();
              setSelectedIndex((prev) => Math.max(prev - 1, 0));
            }}
            className="py-5 px-8 md-max:py-3 md-max:px-4 border-[#3D74C0] border rounded-[10px] flex gap-4 text-lg md-max:text-base font-medium items-center justify-center"
          >
            <FaArrowLeftLong /> Back
          </button>
          <button
            onClick={() => {
              scrollToTop();
              setSelectedIndex((prev) => Math.min(prev + 1, 5));
            }}
            className="py-5 px-8 md-max:py-3 md-max:px-4 border border-[#3D74C0] bg-[#3D74C0] text-white rounded-[10px] flex gap-4 text-lg md-max:text-base font-medium items-center justify-center"
          >
            Next <FaArrowRightLong />
          </button>
        </div>
      </div>

      <ResultFeedbackModal
        visible={feedbackVisible}
        onHide={() => setFeedbackVisible(false)}
      />
    </>
  );
};

export default NavigationButtons;
